import React from "react";

interface PdfViewerProps {
    pdfUrl: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ pdfUrl }) => {
    return (
        <div className="h-96 border">
            <iframe src={pdfUrl} width="100%" height="100%" title="PDF Viewer" />
        </div>
    );
};

export default PdfViewer;
